import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { ChatMessage, ChatClient } from 'api/clients/ChatClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { chatKeys } from './chatKeys'
import { reportError } from 'utils/error'

export interface Data {
  messages: ChatMessage[]
}

export interface Variables {
  threadId: number
  id: number
}

export const abortMessage = async (workspaceId: number, variables: Variables) => {
  const response = await ChatClient.abortMessage(workspaceId, variables.threadId, variables.id)

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useAbortMessage = () => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<Data, unknown, Variables>(
    'abortMessage',
    async (variables) => {
      return abortMessage(workspaceId, variables)
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(chatKeys.threadMessages(workspaceId, variables.threadId))
      },
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
    },
  )
}
